import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from '../services';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router';
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private jwtService: JwtService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig = {};
    const registerToken = this.jwtService.getRegisterToken();
    const loginToken = this.jwtService.getLoginToken();
    
     if (loginToken) {
      headersConfig['Authorization'] = `Bearer ${loginToken}`;
    } 

    if (registerToken) {
      headersConfig['Authorization'] = `Bearer ${registerToken}`;
    } 

    const request = req.clone({ setHeaders: headersConfig });
    
    return next.handle(request)
    .do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // process successful responses here
        if (loginToken) {
          const newToken = event.headers.get('newToken');
          if (newToken) {
            //localStorage.setItem('authorizationData', newToken);
            this.jwtService.saveLoginToken(newToken);
          }
        }
        else{
          const newToken = event.headers.get('newToken');
          if (newToken) {
            //localStorage.setItem('authorizationData', newToken);
            this.jwtService.saveRegisterToken(newToken);
          }
        }
      }
    }, (error: any) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 400 || error.status === 401) {
          if (error.error.message == 'The Token has expired') {
            localStorage.clear();
		        this.jwtService.destroyToken();
            this.router.navigate(['/app.pub-login']);
          } else {
            this.router.navigate(['/access-denied']);
          }
        }
      }
    });
  }

}

